module.exports = __webpack_public_path__ + "media/images/front/common/logo-358c2030cd4fbb4083de59ac93e17329.png";